import React, { useEffect, useState, useRef } from 'react'
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import TapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom';
import Ax from '../../../components/hoc/Ax';
import DateService from '../../../services/DateService';
import ItemDemandDetail from '../../inventory/itemDemand/ItemDemandDetail';
import { Modal } from 'bootstrap';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import AllocationDetail from '../../inventory/allocation/AllocationDetail';
import ConsumptionDetailsModal from '../../inventory/consumption/ConsumptionDetailsModal';

function ConsumptionCycleTab(props) {
 const [demand_loading, setDemand_loading]                                 =    useState(false)
  const [demand_listing, setDemand_listing]                                 =    useState([])
  const [demandlistingMeta, setDemandlistingMeta]                           =    useState({})
  const [demandtotalListingCount, setDemandtotalListingCount]               =    useState(null)
 const [selectedDemandId, setSelectedDemandId]                             =    useState(null)
  const [allocationlistingMeta, setAllocationlistingMeta]                   =    useState(null)
  const [consumptionlistingMeta, setConsumptionlistingMeta]                 =    useState(null)
  const [allocation_listing, setAllocation_listing]                         =    useState([])
  const [consumption_listing, setConsumption_listing]                       =    useState([])
  const [allocation_loading, setAllocation_loading]                         =    useState(false)
  const [consumption_loading, setConsumption_loading]                       =    useState(false)
  const [allocationtotalListingCount, setAllocationtotalListingCount]       =    useState(0)
  const [consumptiontotalListingCount, setConsumptiontotalListingCount]     =    useState(0)
  const [selectedAllocationId, setSelectedAllocationId]                     =    useState("")
  const [selectedConsumptionId, setSelectedConsumptionId]                   =    useState("")
  const [showOtherDetail, setShowOtherDetail]                               =    useState(props && props?.data && props?.data?.showOtherDetail && props?.data?.showOtherDetail == "N" ? "N" : "Y",)
  // Modal refs
  const viewDemandDetailModalRef = useRef(null)
  const viewAllocationDetailModalRef = useRef(null)
  const viewConsumptionDetailModalRef = useRef(null)
     const permissions = useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);

  // Modal element refs
  const viewDemandDetailModalElem = useRef(null)
  const viewAllocationDetailModalElem = useRef(null)
  const viewConsumptionDetailModalElem = useRef(null)

  const accessToken             =     useSelector(state => state.auth.access_token)
  const group_permission        =     useSelector(state => state.app.acl_info)
  const demandListUrl           =     INVENTORY_API_BASE_URL_2 + "/item_demand/list";
  const allocationListUrl       =     INVENTORY_API_BASE_URL_2 + "/allocations";
  const consumptionListUrl      =     INVENTORY_API_BASE_URL_2 + "/consumptions";

  // Modal initialization
  useEffect(() => {
    if (showOtherDetail === "Y") {
      // Initialize modals only when needed
      const demandModalElement = document.getElementById("viewDemandDetailModal")
      const allocationModalElement = document.getElementById("viewAllocationDetailModal")
      const consumptionModalElement = document.getElementById("viewConsumptionDetailModal")

      if (demandModalElement && !viewDemandDetailModalRef.current) {
        viewDemandDetailModalRef.current = new Modal(demandModalElement, { 
          keyboard: false, 
          backdrop: false 
        })
      }

      if (allocationModalElement && !viewAllocationDetailModalRef.current) {
        viewAllocationDetailModalRef.current = new Modal(allocationModalElement, { 
          keyboard: false, 
          backdrop: false 
        })
      }

      if (consumptionModalElement && !viewConsumptionDetailModalRef.current) {
        viewConsumptionDetailModalRef.current = new Modal(consumptionModalElement, { 
          keyboard: false, 
          backdrop: false 
        })
      }
    }
  }, [showOtherDetail])

  // Cleanup modals on component unmount
  useEffect(() => {
    return () => {
      if (viewDemandDetailModalRef.current) {
        viewDemandDetailModalRef.current.hide()
      }
      if (viewAllocationDetailModalRef.current) {
        viewAllocationDetailModalRef.current.hide()
      }
      if (viewConsumptionDetailModalRef.current) {
        viewConsumptionDetailModalRef.current.hide()
      }
    }
  }, [])

  const getDemandList = (page = 1, search_ticket_id = "") => {
    setDemand_loading(true)
    let params = {
      page: page, search_ticket_id: props.data.ticketData
        ? props.data.ticketData.activity_id
        : [],
    };
    HttpAPICall.withAthorization("GET", demandListUrl, accessToken, params, {}, (resp) => {
      let respData = resp.data;
      setDemand_listing(respData.data)
      setDemandlistingMeta({
        from: respData.from,
        to: respData.to,
        total: respData.total,
        last_page: respData.last_page,
        per_page: respData.per_page,
        current_page: respData.current_page,
      })
      setDemandtotalListingCount(respData.total)
  }
    ).then(() => setDemand_loading(false)
    );
  };

  const getAllocationList = (page = 1, search_ticket_id = "") => {
    setAllocation_loading(true)
    let params = {
      page: page,
     search_ticket_id: props.ticketData
        ? props.ticketData.activity_id
        : null,
    };
    HttpAPICall.withAthorization(
      "GET",
      allocationListUrl,
      accessToken,
      params,
      {},
      (resp) => {
        let respData = resp.data;
        setAllocation_listing(respData.data)
        setAllocationlistingMeta(respData.meta)
        setAllocationtotalListingCount(respData.meta.total)
      }
    ).then(() => setAllocation_loading(false)
    );
  };
  const getConsumptionList = (page = 1, search_ticket_id = "") => {
    setConsumption_loading(true)
    let params = {
      page: page,
       search_ticket_id: props.ticketData
        ? props.ticketData.activity_id
        : null,
    };
    HttpAPICall.withAthorization(
      "GET", consumptionListUrl, accessToken, params, {}, (resp) => {
        let respData = resp.data;
        setConsumption_listing(respData.data)
        setConsumptionlistingMeta(respData.meta)
        setConsumptiontotalListingCount(respData.meta.total)
      }
    ).then(() => setConsumption_loading(false)
    );
  };


  useEffect(() => {
  const ticketData = props?.data?.ticketData || props?.ticketData;
    
    if (
      ticketData &&
      ticketData.setting &&
      ticketData.setting.ticket_demand == "Y" &&
      group_permission && group_permission.group_modules.includes("isc") &&
      ticketData.total_demands
    ) {
      getDemandList(1,  ticketData.activity_id);
    }
    if (
     ticketData &&
     ticketData.setting &&
     ticketData.setting.ticket_allocation == "Y" &&
      group_permission &&
      group_permission.group_modules.includes("isc") &&
      allocation_listing.length === 0
    ) {
      getAllocationList(1, ticketData.activity_id);
    }
    if (
     ticketData &&
     ticketData.setting &&
     ticketData.setting.ticket_consumption == "Y" &&
      group_permission &&
      group_permission.group_modules.includes("isc") &&
      consumption_listing.length === 0
    ) {
      getConsumptionList(1, ticketData.activity_id);
    }

  }, [])

  const viewDemandDetail = (id) => {
    if (showOtherDetail == "Y") {
      setSelectedDemandId(id)
      if (viewDemandDetailModalRef.current) {
        viewDemandDetailModalRef.current.show()
      }
    }
  };

  const viewAllocationDetail = (id) => {
    if (showOtherDetail == "Y") {
      setSelectedAllocationId(id)
      if (viewAllocationDetailModalRef.current) {
        viewAllocationDetailModalRef.current.show()
      }
    }
  };

  const viewConsumptionDetail = (id) => {
    if (showOtherDetail == "Y") {
      setSelectedConsumptionId(id)
      if (viewConsumptionDetailModalRef.current) {
        viewConsumptionDetailModalRef.current.show()
      }
    }
  };
  const demandDetailsModalJsx = () => {

    return (
      <div className="modal fade" id="viewDemandDetailModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="searchItemModalLabel">
                Demand Details
              </h5>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  if (viewDemandDetailModalRef.current) {
                    viewDemandDetailModalRef.current.hide()
                  }
                }}
              >
                Close
              </button>
            </div>
            <div className="modal-body">
              <ItemDemandDetail demandId={selectedDemandId} />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const consumptionDataJsx = () => {
    let totalAllocationQty = 0;
    let totalPendingQty = 0;
    let totalConsumptionQty = 0;
    let totalConsumptionAmt = 0;
console.log(props.ticketData);
  const ticketData = props?.data?.ticketData || props?.ticketData;

    return (
      <>
         {group_permission &&
          group_permission.group_modules.includes("isc") && (
          <Ax>
            {
            ticketData &&
              ticketData.setting &&
              ticketData.setting.ticket_demand &&
              ticketData.setting.ticket_demand == "Y" && (
                <>
                  <div className="tab_content_wrapper mt-2">
                    <span className="content_heading">Item Demand</span>
                    {permissions.includes('isc_item_demand_add') &&
                      <div className="col-sm-2 text-end">
                        {ticketData &&
                          ticketData.status !== 0 && ticketData.ticket_for !== "site" && ticketData.ticket_for !== "site" && (
                            <Link 
                              target="_blank"
                              // disabled={!this.props.permissions.includes('isc-consumption-add')}
                              to={{
                                pathname: "/item_demand_add",
                                search:
                                  "?" +
                                  new URLSearchParams({
                                    ticketId:
                                      ticketData.activity_id
                                        ? ticketData.activity_id
                                        : "",
                                  }).toString(),
                              }}
                            >
                              <TapIcon.FontAwesomeIcon
                                icon={TapIcon.faPlus}
                                alt="item-action"
                              />
                            </Link>)}
                      </div>
                    }
                  </div>
                  <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
                   {
                      demand_loading
                        ?
                        <tr>
                          <td className="text-center" colSpan={7}><Loader /></td>
                        </tr>
                        :
                        demand_listing.length > 0
                          ?
                      <>
                        <thead className="table-secondary">
                          <tr>
                            <td colSpan={6}>
                              <b>Total Demand Qty</b>
                            </td>
                            <td className="text-end">
                              {ticketData.total_demands
                                ? ticketData.total_demands.total_qty
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="col" style={{ width: "5%" }}>
                              S.no
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              Date
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              Transaction ID
                            </th>
                            <th scope="col" style={{ width: "20%" }}>
                              Warehouse
                            </th>
                            <th scope="col" style={{ width: "35%" }}>
                              Demand For
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              Total Qty
                            </th>

                            <th scope="col" style={{ width: "10%" }}>
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {demand_listing.map(
                                (item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        {demandlistingMeta
                                          ? demandlistingMeta
                                            .from + index
                                          : index}
                                </td>
                                <td className="text-center">
                                  {DateService.dateTimeFormat(
                                    item.transaction_date,
                                    "DD-MMM-YYYY"
                                  )}
                                </td>
                                  <td className="text-center link-primary" style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          viewDemandDetail(
                                            item.transaction_id
                                          )
                                        }
                                      >
                                {item.transaction_id
                                            ? item.transaction_id
                                            : "-"}
                                </td>
                                <td className="text-capitalize">
                                  {item.warehouse ? (
                                    <div>{item.warehouse.name}</div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {item.asset ? (
                                    <div>
                                      <small className="form-text">
                                          {item.demand_for == "asset"
                                                ? "Asset : "
                                                : ""}
                                            </small>{" "}
                                            {item.asset.name} (
                                            {item.asset.asset_code})
                                    </div>
                                  ) : item.workstation ? (
                                    <div>
                                      <small className="form-text">
                                       {item.demand_for ==
                                                "workstation"
                                                ? "Workstation : "
                                                : ""}
                                            </small>{" "}
                                     {
                                              item.workstation
                                                .workstation_name
                                            }{" "}
                                          </div>
                                        ) : item.sub_assembly ? (
                                          <div>
                                            <small className="form-text">
                                              {item.demand_for ==
                                                "sub_assembly"
                                                ? "Sub Assembly : "
                                                : ""}
                                            </small>{" "}
                                      {item.sub_assembly.name}{" "}
                                    </div>
                                  ) : item.employee ? (
                                    <div>
                                      <small className="form-text">
                                        {item.demand_for ==
                                                "employee"
                                                ? "Employee : "
                                                : ""}
                                                </small>{" "}
                                      {item.employee.name}{" "}
                                    </div>
                                  ) : (
                                    ""
                                  )}{" "}
                                </td>
                                <td>{item.total_qty}</td>
                                <td>
                                 {item.status
                                          ? item.status.name
                                          : ""}
                                </td>
                           </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </>
                          :
                          <tbody>
                        <tr>
                         <td className="text-center" colSpan={7}>No Records</td>
                        </tr>
                      </tbody>
                    }
                  </table>
                 {
                    demand_listing &&
                    demand_listing.length > 0 &&
                    <DisplayListPagination
                      meta={demandlistingMeta}
                      onPageChange={(e) =>
                        getDemandList(e.selected + 1)
                      }
                    />
                  }
                </>)
            }
              {

            ticketData &&
              ticketData.setting &&
              ticketData.setting.ticket_allocation &&
              ticketData.setting.ticket_allocation == "Y" && 
                <>
                  <div className="tab_content_wrapper mt-2">
                    <span className="content_heading"> Allocation</span>
                    { permissions.includes('isc-allocation-add') && ticketData &&
                      ticketData.status !== 0 && ticketData.ticket_for !== "site" && (
                        <div className="col-sm-2 text-end">
                          <Link
                            target="_blank"
                            to={{
                               pathname:
                              "/allocation_list/add",
                            search:
                              "?" +
                              new URLSearchParams({
                                ticketId:
                                  ticketData.activity_id
                                    ? ticketData.activity_id
                                    : "",
                              }).toString(),
                            }}
                          >
                            <TapIcon.FontAwesomeIcon
                              icon={TapIcon.faPlus}
                              alt="item-action"
                            />
                          </Link>
                        </div>
                      )}
                  </div>
                  <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
                    {
                      allocation_loading
                        ?
                         <tr>
                          <td className="text-center" colSpan={7}><Loader /></td>
                        </tr>
                    :
                        allocation_listing.length > 0
                          ?
                      <>
                        <thead className="table-secondary">
                          <tr>
                            <th colSpan={6}>Total Allocation Qty</th>
                            <td className="text-end">
                              {ticketData.total_allocation
                                ? ticketData.total_allocation.total_qty
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="col" style={{ width: "5%" }}>
                              S.no
                            </th>
                            <th scope="col" style={{ width: "15%" }}>
                              Date
                            </th>
                            <th scope="col" style={{ width: "15%" }}>
                              Transaction ID
                            </th>
                            <th scope="col" style={{ width: "30%" }}>
                              Warehouse
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              Total Qty
                            </th>
                            <th scope="col" style={{ width: "10%" }}>
                              Pending Qty
                            </th>
                            <th scope="col" style={{ width: "15%" }}>
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {allocation_listing.map(
                                (item, index) => {
                            totalAllocationQty += item.total_qty
                              ? parseInt(item.total_qty)
                              : 0;
                             totalPendingQty +=
                                    item.total_pending_qty
                              ? parseInt(item.total_pending_qty)
                              : 0;
                            return (
                              <tr key={index}>
                                <td>
                                  {allocationlistingMeta
                                   ? allocationlistingMeta
                                            .from + index
                                    : index}
                                </td>
                                <td className="text-center">
                                  {item.transaction_date_display}
                                </td>
                              <td className="text-center link-primary"
                                  style={{ cursor: "pointer" }}
                                 onClick={() =>
                                          viewAllocationDetail(
                                            item.transaction_id
                                          )
                                        }
                                      >
                                    {item.transaction_id
                                          ? item.transaction_id
                                          : "-"}

                                      </td>
                                <td className="text-capitalize">
                                  {item.warehouse ? (
                                    <div>{item.warehouse.name}</div>
                                  ) : (
                                    "-"
                                  )}
                                </td>

                                <td className="text-end">
                                  {item.total_qty ? item.total_qty : 0}
                                </td>
                                <td className="text-end">
                                  {item.total_pending_qty
                                          ? item.total_pending_qty
                                          : 0}
                                </td>
                                <td className="text-center">
                                   {item.status_data
                                          ? item.status_data.name
                                          : "-"}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </>
                          :
                          <tbody>
                            <tr>
                              <td className="text-center" colSpan={7}>No Records</td>
                            </tr>
                          </tbody>
                    }
                  </table>
                     {
                    allocation_listing &&
                    allocation_listing.length > 0 &&
                    <DisplayListPagination
                      meta={allocationlistingMeta}
                      onPageChange={(e) =>
                        getAllocationList(e.selected + 1)
                      }
                    />
                  }
                </>
              }
             {
                ticketData &&
                ticketData.setting &&
                ticketData.setting.ticket_consumption &&
                ticketData.setting.ticket_consumption == "Y" &&
                <>
                  <div className="tab_content_wrapper mt-2">
                    <span className="content_heading"> Consumption</span>
                    { permissions.includes('isc-consumption-add') && ticketData &&
                    ticketData.status !== 0 && ticketData.ticket_for !== "site" && (
                      <div className="col-sm-2 text-end">
                        <Link
                          target="_blank"
                          to={{
                            pathname:
                              "/consumption_list/add",
                            search:
                              "?" +
                              new URLSearchParams({
                                ticketId:
                                  ticketData.activity_id
                                    ? ticketData.activity_id
                                    : "",
                              }).toString(),
                          }}
                        >
                          <TapIcon.FontAwesomeIcon
                            icon={TapIcon.faPlus}
                            alt="item-action"
                          />
                        </Link>
                      </div>
                    )}
                  </div>
                  <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
                    {
                      consumption_loading
                        ?
                        <tr>
                          <td className="text-center" colSpan={7}><Loader /></td>
                        </tr>
                        :
                        consumption_listing.length > 0
                          ?
                          <>
                            <thead className="table-secondary">
                              <tr>
                                <td colSpan={4}>
                                  <b>Total Consumption Qty/Amount</b>
                                </td>
                                <td className="text-end">
                                  {ticketData.total_consumption
                                    ? ticketData.total_consumption.total_qty
                                    : "-"}
                                </td>
                                <td className="text-end">
                                  {ticketData.total_consumption
                                    ? ticketData.total_consumption
                                      .sum_total_amount
                                    : "-"}
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <th scope="col" style={{ width: "5%" }}>
                                  S.no
                                </th>
                                <th scope="col" style={{ width: "15%" }}>
                                  Date
                                </th>
                                <th scope="col" style={{ width: "15%" }}>
                                  Transaction ID
                                </th>
                                <th scope="col" style={{ width: "30%" }}>
                                  Warehouse
                                </th>
                                <th scope="col" style={{ width: "10%" }}>
                                  Total Qty
                                </th>
                                <th scope="col" style={{ width: "10%" }}>
                                  Amount
                                </th>
                                <th scope="col" style={{ width: "15%" }}>
                                  Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {consumption_listing.map(
                                (item, index) => {
                                  totalConsumptionAmt += parseFloat(
                                    item.total_amount
                                  );
                                  totalConsumptionQty += item.total_qty
                                    ? item.total_qty
                                    : 0;
                                  return (
                                    <tr key={index}>
                                      <td>
                                        {consumptionlistingMeta
                                          ? consumptionlistingMeta
                                            .from + index
                                          : index}
                                      </td>
                                      <td className="text-center">
                                        {item.transaction_date_display}
                                      </td>
                                      <td className="text-center link-primary" style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          viewConsumptionDetail(
                                            item.transaction_id
                                          )
                                        }
                                      >
                                        {item.transaction_id
                                          ? item.transaction_id
                                          : "-"}
                                      </td>
                                      <td className="text-capitalize">
                                        {item.warehouse ? (
                                          <div>{item.warehouse.name}</div>
                                        ) : (
                                          "-"
                                        )}
                                      </td>

                                      <td className="text-end">
                                        {item.total_qty
                                          ? item.total_qty
                                          : 0}
                                      </td>
                                      <td className="text-end">
                                        {item.total_amount ? (
                                          <CurrencyFormatter
                                            currencyCode={props.data.default_currency
                                            }
                                            amount={parseFloat(
                                              item.total_amount
                                            ).toFixed(2)}
                                          />
                                        ) : (
                                          0
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {item.status_data
                                          ? item.status_data.name
                                          : "-"}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </>
                          :
                          <tbody>
                            <tr>
                              <td className="text-center" colSpan={7}>No Records</td>
                            </tr>
                          </tbody>
                    }
                  </table>
                  {
                    consumption_listing &&
                    consumption_listing.length > 0 &&
                    <DisplayListPagination
                      meta={consumptionlistingMeta}
                      onPageChange={(e) =>
                        getConsumptionList(e.selected + 1)
                      }
                    />
                  }
                </>
              }
            </Ax>
          )}
      </>
    )
  };

  const allocationDetailsModalJsx = () => {
    return (
      <div className="modal fade" id="viewAllocationDetailModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="searchItemModalLabel">
                Allocation Detail
              </h5>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  if (viewAllocationDetailModalRef.current) {
                    viewAllocationDetailModalRef.current.hide()
                  }
                }}
              >
                Close
              </button>
            </div>
            <div className="modal-body">
           <AllocationDetail
                allocationId={selectedAllocationId}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const consumptionDetailsModalJsx = () => {
    return (
      <div className="modal fade" id="viewConsumptionDetailModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="searchItemModalLabel">
                Consumption Details
              </h5>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  if (viewConsumptionDetailModalRef.current) {
                    viewConsumptionDetailModalRef.current.hide()
                  }
                }}
              >
                Close
              </button>
            </div>
            <div className="modal-body">
               <ConsumptionDetailsModal
                consumptionId={selectedConsumptionId}
              />            
              </div>
          </div>
        </div>
      </div>
    );
  };


  return (
    <>
      {consumptionDataJsx()}

      {demandDetailsModalJsx()}
      {allocationDetailsModalJsx()}
      {consumptionDetailsModalJsx()}
    </>
  )
}

export default ConsumptionCycleTab